import React, { useState, useEffect } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import { Container } from "components";
import { Button } from "components";
import { ProductMastheadTitle } from "components/templates/ProductPage/ProductPageMastheadTitle";
import { ProductNavigation } from "components/templates/ProductPage/ProductNavigation";
import { ProductMastheadCheckpoints } from "components/templates/ProductPage/ProductPageMastheadCheckpoints";
import { EXTERNAL_LINKS } from "config/routes";
import { ProductPageMastheadPress } from "components/templates/ProductPage/ProductPageMastheadPress";
import { IProduct } from "interfaces/product.interface";
import { ProductMastheadVideo } from "components/templates/ProductPage/ProductPageMastheadVideo";
import { ProductMastheadImage } from "./ProductMastheadImage";

export const ProductMasthead = ({
  product,
  cover,
  customGetStarted,
  onDemoButtonClick,
  hasVideo,
}: {
  product: IProduct;
  cover: string;
  onDemoButtonClick?(): void;
  customGetStarted?: string;
  hasVideo?: boolean;
}) => {
  const links = [
    {
      label: "Overview",
      to: "overview",
    },
    {
      label: "Features",
      to: "features",
    },
    {
      label: "Pricing",
      to: "pricing",
    },
  ];

  const { summary, description, color, keyBenefits } = product;

  const [isScrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 200) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  return (
    <Box pos="relative">
      <ProductNavigation
        product={product}
        links={links}
        isSticky={isScrolled}
      />
      <Container>
        <Box display={{ base: "block", lg: "flex" }} alignItems="center">
          <Box flex={1} maxW="lg">
            <ProductMastheadTitle>{summary}</ProductMastheadTitle>
            <Box fontSize="xl" mb={4} fontWeight={500}>
              {description}
            </Box>
            <ProductMastheadCheckpoints color={color} items={keyBenefits} />
            <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={4}>
              <Box>
                <Box
                  as="a"
                  href={customGetStarted || EXTERNAL_LINKS.SIGNUP_UP.href}
                  display="block"
                  width="100%"
                >
                  <Button color={color} size="lg" isWide isBlock>
                    Get started
                  </Button>
                </Box>
              </Box>
            </SimpleGrid>
          </Box>
          {hasVideo ? (
            <ProductMastheadVideo product={product} cover={cover} />
          ) : (
            <ProductMastheadImage product={product} cover={cover} />
          )}
        </Box>
        <ProductPageMastheadPress />
      </Container>
    </Box>
  );
};
